/* eslint-env browser */

require('../../container/client')

if (module.hot) {
  module.hot.accept()
}
